import PDFBuilder, { fmtDate, fmtDateFromISO, formatCI } from "../../utils/pdfBuilder.js";

const motivLabels = {
  neplata: "neplata chiriei",
  reparatii: "neefectuarea reparatiilor necesare de catre proprietar",
  denuntare: "denuntarea unilaterala a contractului, cu respectarea termenului de preaviz",
};

export default function buildNotificareRezilierePDF(data, filename) {
  const pdf = new PDFBuilder();
  const today = fmtDate(new Date());

  const expeditorTip = data.expeditorEsteChirias ? "Chirias" : "Proprietar";
  const destinatarTip = data.expeditorEsteChirias ? "Proprietar" : "Chirias";
  const dataNotificareFmt = data.dataNotificare ? fmtDateFromISO(data.dataNotificare) : today;

  const preavizZile = data.preaviz === "alt" ? (data.preavizCustom || "___") : (data.preaviz || "___");
  const motivText = data.motivReziliere === "altele"
    ? (data.motivDetalii || "___________________________")
    : (motivLabels[data.motivReziliere] || "___________________________");

  // Title
  pdf.title("Notificare de Reziliere", "Contract de Inchiriere");

  // Date
  pdf.p(`Data: ${dataNotificareFmt}`, { indent: 0, size: 10 });

  // Expeditor section
  pdf.section(`Expeditor (${expeditorTip})`);
  pdf.field("Nume", data.expeditorNume);
  pdf.field("CNP", data.expeditorCNP);
  pdf.field("CI seria", data.expeditorCI ? formatCI(data.expeditorCI) : "___ ___");
  pdf.field("Domiciliul", data.expeditorAdresa);

  // Destinatar section
  pdf.section(`Destinatar (${destinatarTip})`);
  pdf.field("Nume", data.destinatarNume);
  pdf.field("Adresa", data.destinatarAdresa);

  // Body paragraphs
  pdf.pMixed([
    { text: "Subsemnatul/a, " },
    { text: data.expeditorNume || "________________________", bold: true },
    { text: ", in calitate de " },
    { text: expeditorTip.toLowerCase(), bold: true },
    { text: " al imobilului situat in " },
    { text: data.contractAdresaImobil || "________________________", bold: true },
    { text: ", in temeiul contractului de inchiriere nr. " },
    { text: data.contractNumar || "___", bold: true },
    { text: " din data de " },
    { text: data.contractData ? fmtDateFromISO(data.contractData) : "___________", bold: true },
    { text: "," },
  ]);

  pdf.pMixed([
    { text: "va aduc la cunostinta prin prezenta notificare decizia mea de " },
    { text: "reziliere a contractului de inchiriere", bold: true },
    { text: " mentionat mai sus, avand ca motiv: " },
    { text: motivText, bold: true },
    { text: "." },
  ]);

  pdf.pMixed([
    { text: "In conformitate cu prevederile contractuale si ale Codului Civil, va acord un termen de preaviz de " },
    { text: `${preavizZile} zile`, bold: true },
    { text: "." },
  ]);

  pdf.pMixed([
    { text: "Prin urmare, contractul de inchiriere va inceta sa produca efecte incepand cu data de " },
    { text: data.dataIncetare ? fmtDateFromISO(data.dataIncetare) : "___________", bold: true },
    { text: "." },
  ]);

  const actionText = data.expeditorEsteChirias
    ? "predarea imobilului conform conditiilor contractuale, inclusiv eliberarea imobilului si restituirea cheilor la data mentionata mai sus."
    : "eliberarea imobilului si predarea cheilor la data mentionata mai sus, conform conditiilor contractuale.";

  pdf.p(`Va rog sa luati act de prezenta notificare si sa procedati la ${actionText}`);

  pdf.p("De asemenea, va rog sa aveti in vedere urmatoarele:");

  pdf.p("- Regularizarea tuturor obligatiilor financiare restante (chirii, utilitati)", { indent: 5 });
  pdf.p("- Intocmirea procesului-verbal de predare-primire a imobilului", { indent: 5 });
  pdf.p("- Restituirea garantiei, dupa caz, conform prevederilor contractuale", { indent: 5 });

  pdf.p("Prezenta notificare a fost intocmita in doua exemplare si transmisa prin scrisoare recomandata cu confirmare de primire / inmanata personal sub semnatura.");

  // Signature
  pdf.signatureSingle({
    role: expeditorTip.toUpperCase(),
    name: data.expeditorNume || "",
    date: dataNotificareFmt,
  });

  pdf.save(filename);
}
